import { FlexBox, Text } from '@dixa/lib-shared-habla';
import { colors, typography } from '@dixa/lib-shared-tokens';

export const StoryExpired = (): JSX.Element => {
  return (
    <FlexBox
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      padding="400"
      gap="100"
      height="250px"
      background={colors.neutral['200']}
    >
      <Text.Heading variant="heading-3" color={typography.color.secondary}>
        Story is unavailable
      </Text.Heading>
      <Text.Paragraph variant="2" color={typography.color.secondary}>
        You can no longer see this story because it expired
      </Text.Paragraph>
    </FlexBox>
  );
};
